module.exports = __webpack_public_path__ + "src/assets/textures/micropipette/plane_mat21.jpg";